export default __webpack_public_path__ + "media/zurb/img/home/home-tool-sketch-e1a84039e6e86eecc54996f435ab4b11.png";